import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
dayjs.locale('ja');
export const SECONDS_OF_ONE_MINUTE = 60;
export const MINUTES_OF_ONE_HOUR = 60;
export const DAYS_OF_ONE_WEEK = 7;
export const ONE_DAY_IN_MS = 86400000;
export const ONE_WEEK_IN_MS = 604800000;
export const MAX_DATE_TIMESTAMP = 4102326000000; // 2099-12-31 00:00:00
export const isToday = (year, month, date) => {
    const d = new Date();
    return d.getDate() === date && d.getMonth() + 1 === month && d.getFullYear() === year;
};
export const dateIsToday = (date) => {
    return dayjs(date).isToday();
};
export const isYesterday = (year, month, date) => {
    const d = new Date();
    d.setDate(d.getDate() - 1);
    return d.getDate() === date && d.getMonth() + 1 === month && d.getFullYear() === year;
};
// 一週間以内かどうか判定する.(将来の日付の場合false)
export const isWithinOneWeek = (year, month, date) => {
    const now = new Date();
    now.setHours(23, 59, 59, 999); // 当日 23:59:59
    const d = new Date(year, month - 1, date);
    const dateDiff = (now.getTime() - d.getTime()) / (1000 * 60 * 60 * 24);
    return dateDiff < 7 && dateDiff >= 0;
};
export const getLastDayOfMonth = (y, m) => {
    return new Date(y, m, 0).getDate();
};
// 指定した日付が今日から指定日数以内かどうか判定する
export const isWithinDaysFromToday = (date, dayCount) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const targetDate = new Date(date);
    targetDate.setHours(0, 0, 0, 0);
    const thresholdDate = new Date(today);
    thresholdDate.setDate(today.getDate() + dayCount);
    return targetDate.getTime() <= thresholdDate.getTime();
};
// 日付のフォーマットを行う。（出力例：2019-01-25 12:50:30）
export const getFormatedDateTime = (date) => {
    return (date.getFullYear() +
        '-' +
        appendLeadingZeroes(date.getMonth() + 1) +
        '-' +
        appendLeadingZeroes(date.getDate()) +
        ' ' +
        appendLeadingZeroes(date.getHours()) +
        ':' +
        appendLeadingZeroes(date.getMinutes()) +
        ':' +
        appendLeadingZeroes(date.getSeconds()));
};
// 日付が一桁の場合に頭に「0」を付与する（例：5 → 05）
const appendLeadingZeroes = (n) => {
    return n < 10 ? `0${n}` : n;
};
export const getUnixTimeInUTC = (date) => {
    // new Dateはロケーションを自動的に判断して時間を返す。
    // UTCにするためにタイムゾーンを取得してオフセットタイムを
    // 調整してUTC時間を取得する
    return new Date(date.getTime() + date.getTimezoneOffset() * 60000);
};
export const getDiffDays = (countdownEndDate, nowDate) => {
    // 日付の差分を見たいので、対象時間を0時にする
    return dayjs(countdownEndDate).startOf('date').diff(nowDate, 'd');
};
export const isNowAfter = (msUnixtime) => {
    return Date.now() > msUnixtime;
};
export const sameDay = (targatDate, nowDate) => {
    const parsedTargatDate = `${targatDate.getFullYear()}-${targatDate.getMonth()}-${targatDate.getDate()}`;
    const parsedNowDate = `${nowDate.getFullYear()}-${nowDate.getMonth()}-${nowDate.getDate()}`;
    return parsedTargatDate === parsedNowDate;
};
export const exceedDay = (msUnixtime) => {
    return Date.now() - msUnixtime > ONE_DAY_IN_MS;
};
export const exceedWeek = (msUnixtime) => {
    return Date.now() - msUnixtime > ONE_WEEK_IN_MS;
};
export const convertUnixToDate = (unixtime) => {
    return new Date(unixtime * 1000);
};
// YYYY.M.D の形式にフォーマット(例: 2021.4.11)
export const formatedDate = (unixtime) => {
    const date = convertUnixToDate(unixtime).toLocaleDateString();
    const formatedDate = dayjs(date).format('YYYY.M.D');
    return formatedDate;
};
export const getLastWeekMonday = () => {
    const date = new Date();
    const lastWeekMonday = new Date();
    const dayNum = date.getDay() == 0 ? 7 : date.getDay() + 6;
    lastWeekMonday.setDate(date.getDate() - dayNum);
    return lastWeekMonday;
};
// 日付として正しいかチェックする
// date: '2020-02-31'
// format: 'YYYY-MM-DD'
// dayjsのisValidだとformatまでしか確認してくれないため、2020-02-31だとtrueになってしまわないようにdateとの比較を追加
export const validateDate = (date, format) => {
    const splitDate = date.split('-', 3);
    if (Number.isNaN(parseInt(splitDate[0], 10)) ||
        Number.isNaN(parseInt(splitDate[1], 10)) ||
        Number.isNaN(parseInt(splitDate[2], 10))) {
        return false;
    }
    const dayjsDate = dayjs(date, format);
    return dayjsDate.isValid() && dayjsDate.format(format) === date;
};
// DateをYYYY年MM月DD日形式に変換する
export const dateToYearMonthDayString = (date) => {
    return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
};
// YYYY年MM月の形式に変換する
export const getFormatedYearMonth = (year, month) => {
    const yearMonth = new Date(year, month - 1);
    return `${yearMonth.getFullYear()}年${yearMonth.getMonth() + 1}月`;
};
// タイムスタンプからYYYY年MM月の形式に変換する
// "2020-09-16T13:06:28+09:00" を2020年09月
export const getFormatedTimestampToYearMonth = (timestamp) => {
    const yearMonth = new Date(timestamp);
    return `${yearMonth.getFullYear()}年${yearMonth.getMonth() + 1}月`;
};
// YYYY/MM/DD の形式にフォーマット(例: 2021/04/11)
export const getFormattedToSlashFormat = (unixtime) => {
    const date = convertUnixToDate(unixtime);
    return dayjs(date).format('YYYY/MM/DD');
};
// YYYYMMDD の形式にフォーマット(例: 20210411)
export const getFormattedToFormat = (date) => {
    return dayjs(date).format('YYYYMMDD');
};
// YYYY-MM-DD の形式にフォーマット(例: 2021-04-11)
export const getFormattedDateToHyphenFormat = (date) => {
    return dayjs(date).format('YYYY-MM-DD');
};
// YYYYMMDD 形式から M月D日 ddd曜日へと変換
export const getFormattedToMonthDateDay = (date) => {
    return dayjs(date).locale('ja').format('M月D日 ddd曜日');
};
// M月D日(ddd) の形式にフォーマット(例: 10月23日(金))
export const getFormattedToMonthDateWithDayOfWeek = (date) => {
    return dayjs(date).locale('ja').format('M月D日(ddd)');
};
// 今年以外の日付は年度を含めて YYYY年 M月D日 ddd曜日を返す
export const getFormattedWithPastYear = (date) => {
    if (date.getFullYear() === new Date().getFullYear()) {
        return dayjs(date).locale('ja').format('M月D日 ddd曜日');
    }
    else {
        return dayjs(date).locale('ja').format('YYYY年 M月D日 ddd曜日');
    }
};
// YYYYMMDD 形式から Dateへと変換
export const getFormatToDate = (dateString) => {
    return dayjs(dateString, 'YYYYMMDD').locale('ja').toDate();
};
// 文字列を date を使わずに YYYY-MM-DD の形式にフォーマット(例: 2021-04-11)
export const getFormattedToHyphenFormat = (y, m, d) => {
    return `${y}-${('00' + parseInt(m, 10)).slice(-2)}-${('00' + parseInt(d, 10)).slice(-2)}`;
};
export const getCurrentUnixTimeInSeconds = () => Math.round(new Date().getTime() / 1000);
// 8/9 の形式にフォーマット
export const getFormatedDate = (date) => `${date.getMonth() + 1}/${date.getDate()}`;
// Y/m/d 形式にフォーマット
export const getFormattedDateWithYear = (date) => {
    return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
};
export const dayOfWeekEnglish = (date) => ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][date.getDay()];
// xx時間oo分 の形式にフォーマット(例: 1時間22分)
export const getStringDuration = (minutes) => {
    const hours = Math.floor(minutes / MINUTES_OF_ONE_HOUR);
    const remainder = minutes % MINUTES_OF_ONE_HOUR;
    let result = '';
    if (hours > 0)
        result += `${hours}時間`;
    if (remainder > 0)
        result += `${remainder}分`;
    return result;
};
// xx日前 の形式にフォーマット(例: 17日前, 20時間前)
export const getDiffFromCurrent = (msUnixtime) => {
    const diffSeconds = Math.floor((new Date().getTime() - msUnixtime) / 1000);
    const diffMinutes = Math.floor(diffSeconds / 60);
    const diffHours = Math.floor(diffMinutes / 60);
    const diffDay = Math.floor(diffHours / 24);
    const diffMonth = Math.floor(diffDay / 30);
    if (diffSeconds < 60)
        return `${diffSeconds}秒前`;
    if (diffMinutes < 60)
        return `${diffMinutes}分前`;
    if (diffHours < 24)
        return `${diffHours}時間前`;
    if (diffDay < 30)
        return `${diffDay}日前`;
    return `${diffMonth}ヶ月前`;
};
// 8:06 の形式にフォーマット
export const toTimeFromUnix = (unixtime) => {
    const date = convertUnixToDate(unixtime);
    return `${date.getHours().toString()}:${date.getMinutes().toString().padStart(2, '0')}`;
};
// yyyy-m-d の形式にフォーマット
export const toYearMonthDayFromDate = (date) => `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
// hooks 現在時刻のunixtime
export const useNowUnixtime = () => {
    const [now, setNow] = useState(dayjs().unix());
    useEffect(() => {
        const timeId = setInterval(() => setNow((v) => v + 1), 1000);
        return () => clearInterval(timeId);
    }, []);
    return now;
};
// unixtime の単位をミリ秒から秒に変換する
export const convertToSeconds = (msUnixtime) => {
    return Math.floor(msUnixtime / 1000);
};
export const getNearestFiveMinTime = () => {
    const now = new Date();
    return new Date(Math.ceil(now.getTime() / (5 * 60 * 1000)) * (5 * 60 * 1000));
};
// 土曜日基準で何週間前かを返す
// 例: now = 5/24(金)の場合
// | date が 5/19(日) 以降     => 0
// | date が 5/12(日) - 18(土) => 1
// | date が 5/5(日)  - 11(土) => 2
export const weeksFromToday = (date) => {
    const now = dayjs();
    const thisWeekSunday = now.add(6 - now.day(), 'd');
    return thisWeekSunday.diff(dayjs(date), 'w');
};
export const dateMaxToday = (date) => {
    const today = new Date();
    const todayjs = dayjs(today);
    if (todayjs.isBefore(date)) {
        return today;
    }
    else {
        return date;
    }
};
